import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarViews = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.355 6.26a4.01 4.01 0 0 1 4.01-4.01h11.269a4.01 4.01 0 0 1 4.009 4.01v2.076l-.003.165a4.07 4.07 0 0 1-1.421 2.926l-4.655 3.978c-.41.35-.646.863-.646 1.403v1.33c0 1.285-.81 2.433-2.02 2.865l-1.69.604A2.438 2.438 0 0 1 7.95 19.31v-2.647c0-.49-.183-.963-.512-1.324l-4.024-4.422A4.07 4.07 0 0 1 2.355 8.18zm17.788 1.413h-5.428a.75.75 0 1 0 0 1.5h5.288a2.57 2.57 0 0 1-.759 1.114l-4.655 3.978a3.35 3.35 0 0 0-1.171 2.543v1.33c0 .651-.41 1.233-1.025 1.453l-1.69.603a.938.938 0 0 1-1.253-.883v-2.647c0-.863-.321-1.697-.904-2.335l-4.023-4.42a2.57 2.57 0 0 1-.668-1.728v-1.92a2.51 2.51 0 0 1 2.51-2.511h11.269a2.51 2.51 0 0 1 2.509 2.51z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarViews);
export default ForwardRef;
